// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA24KPqYIMPZdOc1UMgy2t_8IR8y60D2AA",
  authDomain: "drumly-mobile.firebaseapp.com",
  projectId: "drumly-mobile",
  storageBucket: "drumly-mobile.firebasestorage.app",
  messagingSenderId: "914876532693",
  appId: "1:914876532693:web:91e098124d004fbfd81f5c",
  measurementId: "G-HE75GPK80Y",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// ✅ Auth objesini oluştur
const auth = getAuth(app);
export { auth };
